<breadcrumb [hidden]="isFakeFullscreen"></breadcrumb>
<div class="content-box" [class.no-padding]="isFakeFullscreen">
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <div class="element-wrapper" [class.no-padding]="isFakeFullscreen">
        <ng-template [ngIf]="!isFakeFullscreen">
          <div class="element-actions" *ngIf="layout >= LAYOUT.SM">
            <ng-select
              class="custom"
              appendTo="body"
              [searchable]="false"
              [clearable]="false"
              (change)="fsChanged($event)"
              placeholder="Textgröße"
            >
              <ng-option [value]="'18'">A <sup>+</sup></ng-option>
              <ng-option [value]="'22'">A <sup>++</sup></ng-option>
              <ng-option [value]="'14'">A <sup>-</sup></ng-option>
            </ng-select>

            <button
              [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'"
              class="btn ml-10"
              (click)="downloadPdf()"
            >
              <i class="fas fa-print fa-fw"></i>
              PDF Download
            </button>

            <button
              [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'"
              class="btn hidden-xs-down"
              (click)="openFullscreen()"
            >
              <i class="fas fa-expand-arrows-alt fa-fw"></i>
              Im Fullscreen öffnen
            </button>
          </div>
          <h6 class="element-header">
            Reservierungsbuch - Reservierungs-System
          </h6>
        </ng-template>

        <div
          class="form-group button-container"
          *ngIf="timeFilter && timeFilter.length > 0"
          [class.no-bottom-margin]="isFullscreen"
        >
          <button
            *ngFor="let timeData of timeFilter; let i = index"
            class="btn btn-white active filter-btn"
            [class.selected]="checkSelectedFilter(timeData.name)"
            (click)="filterReservationWithTimeWithSearch(timeData, true)"
          >
            {{ timeData.name }}
          </button>
        </div>

        <div #fullscreenEl id="fullscreenElement" class="fullscreen-element" [class.is-fullscreen]="isFullscreen">
          <div class="button-bar" #buttonBar fxLayout="row">
            <div class="btn-group column" fxFlexOrder="-1" fxFlex="initial" style="margin-right: 10px">
              <div
                class="btn-group btn-group-toggle"
                ngbRadioGroup
                name="radioBasic"
                [(ngModel)]="view"
                (ngModelChange)="changeView($event)"
              >
                <!-- [class.btn-dark]="isFullscreen" [class.btn-white]="!isFullscreen" -->
                <label ngbButtonLabel [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'">
                  <input ngbButton type="radio" value="list" />
                  <i class="fas fa-list-ul"></i>
                  <ng-template [ngIf]="layout >= LAYOUT.SM || layout < LAYOUT.XS">Liste</ng-template>
                </label>
                <!-- [class.btn-white]="!isFullscreen"  class.btn-dark]="isFullscreen"-->
                <label ngbButtonLabel [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'">
                  <input ngbButton type="radio" value="timeline" />
                  <i class="fas fa-calendar-week"></i>
                  <ng-template [ngIf]="layout >= LAYOUT.SM || layout < LAYOUT.XS">Zeitleiste</ng-template>
                </label>
                <!-- [class.btn-white]="!isFullscreen"
                [class.btn-dark]="isFullscreen" -->
                <label
                  *ngIf="bookSettings?.showTablePlan"
                  ngbButtonLabel
                  [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'"
                >
                  <input ngbButton type="radio" value="tableplan" />
                  <i class="fas fa-table"></i>
                  <ng-template [ngIf]="layout >= LAYOUT.SM || layout < LAYOUT.XS">
                    {{ 'tablePlan.tablePlan' | translate }}
                  </ng-template>
                </label>
              </div>
            </div>

            <div
              class="column date-selection"
              fxFlex
              fxFlexOrder="2"
              fxFlexOrder.gt-xs="1"
              fxFlexGrow="2"
              fxLayoutGap="10px"
            >
              <!-- [class.btn-white]="!isFullscreen"
                [class.btn-dark]="isFullscreen" -->
              <button
                class="btn btn-home-no-padding"
                [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'"
                (click)="today()"
              >
                <i class="fas fa-home"></i>
              </button>
              <div class="btn-group">
                <!-- [class.btn-white]="!isFullscreen"
                [class.btn-dark]="isFullscreen" -->
                <button
                  class="btn btn-margin btn-home-no-padding"
                  [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'"
                  (click)="prevDay()"
                >
                  <i class="fas fa-chevron-left"></i>
                </button>
                <input
                  class="btn-home-no-padding"
                  matInput
                  [matDatepicker]="picker"
                  type="text"
                  [(ngModel)]="currentDate"
                  (dateChange)="changeDate()"
                />
                <!-- [class.btn-white]="!isFullscreen"
                [class.btn-dark]="isFullscreen" -->
                <button
                  class="btn date-btn btn-home-no-padding"
                  [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'"
                  (click)="picker.open()"
                >
                  <ng-template [ngIf]="isToday()">Heute</ng-template>
                  <ng-template [ngIf]="!isToday() && layout >= LAYOUT.MD">{{
                    currentDate | dfnsFormat: 'dddd, DD. MMMM YYYY'
                  }}</ng-template>
                  <ng-template [ngIf]="!isToday() && layout < LAYOUT.MD">{{
                    currentDate | dfnsFormat: 'dd, DD. MMM YYYY'
                  }}</ng-template>
                </button>
                <mat-datepicker #picker></mat-datepicker>
                <!-- [class.btn-white]="!isFullscreen"
                  [class.btn-dark]="isFullscreen" -->
                <button
                  class="btn"
                  [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'"
                  (click)="nextDay()"
                >
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>
              <button
                *ngIf="pendingCounter > 0"
                class="btn btn-warning"
                (click)="openAllPending('pending')"
                [matBadge]="pendingCounter"
                matBadgePosition="after"
                matBadgeColor="accent"
                matTooltip="Offene Reservierungsanfragen"
              >
                <i class="fas fa-hourglass-half"></i>
              </button>
              <button
                *ngIf="waitingCounter > 0"
                class="btn btn-warning"
                (click)="openAllPending('waiting')"
                [matBadge]="waitingCounter"
                matBadgePosition="after"
                matBadgeColor="accent"
                matTooltip="Warteliste"
              >
                <i class="fas fa-clock"></i>
              </button>
            </div>

            <div
              *ngIf="layout > LAYOUT.XS && !isFullscreen"
              class="column"
              fxFlex
              fxFlexOrder="1"
              fxFlexOrder.gt-xs="2"
              fxLayoutGap="5px"
              style="text-align: right;"
            >
              <button
                class="btn"
                [class.btn-white]="!editMode && !isFullscreen"
                [class.btn-dark]="!editMode && isFullscreen"
                [class.btn-warning]="editMode"
                (click)="toggleEditMode()"
                *ngIf="
                  (deviceService?.isMobile() || deviceService?.isTablet()) &&
                  (view === 'timeline' || view === 'tableplan')
                "
              >
                <i class="fas fa-hand-point-up fa-fw"></i>
              </button>
              <button
                class="btn btn-primary"
                (click)="addReservation()"
                *ngxPermissionsOnly="['admin', 'addReservation']"
              >
                <i class="fas fa-plus-circle fa-fw"></i> Neue Reservierung
              </button>
              <!-- [class.btn-white]="!isFullscreen"
              [class.btn-dark]="isFullscreen" -->
              <button
                class="btn btn-margin"
                [ngClass]="activeTheme === 'light-theme' ? 'btn-white' : 'btn-dark'"
                (click)="addReservation(true)"
                *ngxPermissionsOnly="['admin', 'addReservation']"
              >
                <i class="fas fa-plus-square fa-fw"></i> <span *ngIf="layout > LAYOUT.LG">Walk-In</span>
              </button>
              <button class="btn btn-danger btn-margin" (click)="closeFullscreen()" *ngIf="isFullscreen">
                <i class="fas fa-times fa-fw"></i>
              </button>
            </div>

            <div
              *ngIf="layout < LAYOUT.SM || isFullscreen"
              class="column"
              fxFlexOrder="1"
              fxFlexOrder.gt-xs="2"
              fxLayoutGap="5px"
              style="text-align: right;"
            >
              <button
                class="btn"
                [class.btn-white]="!editMode && !isFullscreen"
                [class.btn-dark]="!editMode && isFullscreen"
                [class.btn-warning]="editMode"
                (click)="toggleEditMode()"
                *ngIf="
                  (deviceService?.isMobile() || deviceService?.isTablet()) &&
                  (view === 'timeline' || view === 'tableplan')
                "
              >
                <i class="fas fa-hand-point-up fa-fw"></i>
              </button>
              <button class="btn btn-primary btn-margin btn-open-create" (click)="openCreateBottomSheet()">
                <i class="fas fa-plus-circle fa-fw"></i>
              </button>
              <button class="btn btn-danger btn-margin" (click)="closeFullscreen()" *ngIf="isFullscreen">
                <i class="fas fa-times fa-fw"></i>
              </button>
            </div>
          </div>

          <ng-scrollbar
            [trackX]="false"
            [class.no-scrollbar]="!isFullscreen"
            [shown]="!isFullscreen ? 'native' : 'native'"
            [compact]="true"
            *ngIf="view === 'list'"
          >
            <div [style.height]="isFullscreen ? listHeight : 'initial'">
              <div class="filter-box" fxLayout="row">
                <div
                  *ngIf="hotelIntegration"
                  class="form-group"
                  fxFlex="50"
                  fxFlex.gt-xs="20"
                  [style.padding-right]="layout > LAYOUT.XXS ? '10px' : ''"
                >
                  <label for=""> Nach Gast filtern </label>
                  <ng-select
                    [searchable]="false"
                    [clearable]="true"
                    [(ngModel)]="filter.gast"
                    (change)="searchReservation($event)"
                    placeholder="-- Gast auswählen --"
                    [class.filtered]="filter.gast"
                    [items]="allGastOptions"
                    bindLabel="label"
                    bindValue="value"
                    groupBy="group"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span *ngIf="item.color" class="color-dot" [style.backgroundColor]="item.color"></span>
                      {{ item.label }}
                    </ng-template>
                    <ng-template ng-optgroup-tmp let-item="item">
                      {{ item.group }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <span *ngIf="item.color" class="color-dot" [style.backgroundColor]="item.color"></span>
                      {{ item.label }}
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-group" fxFlex="50" fxFlex.gt-xs="20" style="padding-right: 10px;">
                  <label for=""> In Ergebnissen suchen</label
                  ><input
                    class="form-control"
                    placeholder="Geben Sie einen Gastnamen ein"
                    type="text"
                    [(ngModel)]="filter.name"
                    [class.filtered]="filter.name"
                    (keyup)="searchReservation($event)"
                  />
                </div>
                <div class="form-group" fxFlex="50" fxFlex.gt-xs="20">
                  <div [style.padding-right]="layout > LAYOUT.XXS ? '10px' : ''">
                    <label for=""> Nach Status filtern </label>
                    <ng-select
                      [searchable]="false"
                      [clearable]="true"
                      [(ngModel)]="filter.status"
                      (change)="searchReservation($event)"
                      placeholder="-- Status auswählen --"
                      [class.filtered]="filter.status"
                      [items]="allStatus"
                      bindLabel="label"
                      bindValue="value"
                      groupBy="type"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        <span [class]="item.icon"></span>
                        {{ item.label }}
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                        <span *ngIf="item.type === 'single'">Einzelne</span>
                        <span *ngIf="item.type === 'group'">Gruppiert</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <span [class]="item.icon"></span>
                        {{ item.label }}
                        <small *ngIf="item.description" style="display:block">{{ item.description }}</small>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="form-group" fxFlex="50" fxFlex.gt-xs="20" style="padding-right: 10px;">
                  <label for=""> Nach Raum filtern </label>
                  <ng-select
                    [searchable]="false"
                    [clearable]="true"
                    [(ngModel)]="filter.roomId"
                    [multiple]="true"
                    (change)="searchReservation($event)"
                    placeholder="-- Raum auswählen --"
                    [class.filtered]="filter.roomId"
                  >
                    <ng-container *ngFor="let room of rooms">
                      <!-- Exclude the “All” option (ID: 1000) because it is selected by default. -->
                      <ng-option *ngIf="room.id !== 1000" [value]="room.id">
                        {{ room.name }}
                      </ng-option>
                    </ng-container>
                  </ng-select>
                </div>
                <div class="form-group" fxFlex="50" fxFlex.gt-xs="20">
                  <label for=""> Nach Tags von heute filtern </label>
                  <ng-select
                    [searchable]="!deviceService?.isMobile() && !deviceService?.isTablet()"
                    [items]="tags"
                    [hideSelected]="true"
                    multiple="true"
                    bindLabel="label"
                    (change)="searchReservation($event)"
                    placeholder="-- Tags auswählen --"
                    [(ngModel)]="filter.tags"
                    [class.filtered]="filter.tags && filter.tags.length"
                  >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      <span class="ng-value-label">
                        <i class="fas fa-circle" [style.color]="item.color"></i>
                        {{ item.label }}
                      </span>
                      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <i class="fas fa-circle" [style.color]="item.color" *ngIf="item.color"></i> {{ item.label }}
                    </ng-template>
                  </ng-select>
                </div>
                <div
                  class="form-group"
                  fxFlex="50"
                  fxFlex.gt-xs="20"
                  style="padding-left: 10px;"
                  *ngIf="bookSettings && bookSettings.includeShift > 0"
                >
                  <label for=""> Nach Schicht filtern </label>
                  <ng-select
                    [searchable]="false"
                    [clearable]="true"
                    [(ngModel)]="filter.shiftId"
                    (change)="searchReservation($event)"
                    placeholder="-- Schicht auswählen --"
                    [class.filtered]="filter.shiftId"
                  >
                    <ng-option [value]="shift.id" *ngFor="let shift of shifts">{{ shift.name }}</ng-option>
                  </ng-select>
                </div>
              </div>
              <app-occupancy-per-hour
                *ngIf="bookSettings?.showOccupancy"
                [listOfReservations]="reservations"
              ></app-occupancy-per-hour>
              <p *ngFor="let alert of alerts">
                <ngb-alert type="warning" (close)="closeAlert(alert)" *ngIf="alert.type !== 'guest'"
                  ><strong>Hinweis:</strong>
                  <a *ngIf="alert.fileUrl" href="https://cdn.gastroguide.de/{{ alert.fileUrl }}" class="pdf-files"
                    ><i class="fas fa-file-download file-url-book"></i>
                  </a>
                  {{ alert.info }}
                </ngb-alert>
              </p>
              <p *ngFor="let alert of resMenuOrderAlert">
                <ngb-alert type="info" (close)="closeResMenuOrderAlert(alert)">{{ alert.info }} </ngb-alert>
              </p>
              <div class="element-box list-view" *ngIf="view === 'list'">
                <app-reservations-list
                  [(reservations)]="reservations"
                  [editing]="editing"
                  [isArchiveList]="isArchive"
                  [loading]="loadingReservationList"
                  [date]="currentDate"
                  [isFullscreen]="isFullscreen"
                  [resetTimeFilter]="resetTimeFilter"
                  [reservationListActive]="reservationListActive"
                  [allStatus]="allStatus"
                  [resStatusList]="resStatusList"
                  (reservationsFiltered)="reservationsFiltered($event)"
                  (reservationsChange)="reservationsChange($event)"
                ></app-reservations-list>
              </div>
            </div>
          </ng-scrollbar>

          <div
            class="clearfix timeline-view-wrap"
            [class.timeline-loading]="loadingTimeline"
            *ngIf="view === 'timeline'"
          >
            <!-- Full-view loader: overlays the entire timeline area (room tabs,
                 sidebar, and scheduler) while the dataSource is loading. Replaces
                 reliance on the dx-scheduler's inline spinner, which only covers
                 the scheduler itself. -->
            <div class="timeline-loader-overlay" *ngIf="loadingTimeline">
              <div class="timeline-loader-inner">
                <mat-progress-spinner color="primary" mode="indeterminate" diameter="50"> </mat-progress-spinner>
                <h3>Laden...</h3>
              </div>
            </div>
            <mat-tab-group
              animationDuration="0ms"
              (selectedTabChange)="selectedTabChange($event)"
              [selectedIndex]="tab"
              #roomTabsGroup
            >
              <mat-tab *ngFor="let room of rooms">
                <ng-template mat-tab-label>
                  <i class="fas fa-lock fa-fw" *ngIf="!room.isActive" style="padding-right: 15px;"></i> {{ room.name }}
                </ng-template>
              </mat-tab>
            </mat-tab-group>
            <div class="row timeline-view-row" [class.sidebar-collapsed]="!timelineSidebarOpen">
              <!-- Timeline reservation-card sidebar (show btn + sidebar col)
                   disabled temporarily via *ngIf="false". Keep the markup and
                   the supporting TS methods — this will be re-enabled. -->
              <button
                *ngIf="false"
                type="button"
                class="btn btn-primary btn-sm timeline-sidebar-toggle-btn timeline-sidebar-show-btn"
                (click)="toggleTimelineSidebar()"
                [matTooltip]="'tablePlan.show' | translate"
              >
                <i class="fas fa-chevron-right"></i>
              </button>
              <div *ngIf="false" class="col-md-3 timeline-sidebar">
                <div class="col-md-12">
                  <!-- Search + hide button live on a single row -->
                  <div class="timeline-search-row">
                    <div class="form-group res-search-group mb-0">
                      <i class="fas fa-search res-search-icon"></i>
                      <input
                        class="form-control res-search-input"
                        [placeholder]="'tablePlan.searchGuest' | translate"
                        type="text"
                        [(ngModel)]="filter.name"
                        [class.filtered]="filter.name"
                        (keyup)="searchReservation($event)"
                      />
                    </div>
                    <button
                      type="button"
                      class="btn btn-primary btn-sm timeline-sidebar-toggle-btn timeline-sidebar-hide-btn"
                      (click)="toggleTimelineSidebar()"
                      [matTooltip]="'tablePlan.hide' | translate"
                    >
                      <i class="fas fa-chevron-left"></i>
                    </button>
                  </div>
                  <hr class="res-divider" />
                </div>
                <div *ngIf="reservations.length > 0" class="row res-list">
                  <div class="col-md-12">
                    <div class="room-list">
                      <ng-container *ngFor="let reservation of reservations; let i = index">
                        <div
                          *ngIf="
                            (reservation.guestData && reservation.status != 'canceled') ||
                            (reservation.guestData && reservation.source != 'walkin')
                          "
                          class="reservation-card my-2 row"
                          [ngClass]="{ 'is-selected': reservation.active }"
                          [style.border-left-color]="getCardStatusColor(reservation)"
                          [style.background-color]="lightenColor(getCardStatusColor(reservation), 0.1)"
                        >
                          <div id="timeline-reservation-{{ reservation.id }}" class="col-12">
                            <div
                              class="row reservation-card-item"
                              id="timeline-reservation-list-item{{ i }}"
                              (click)="onSidebarReservationClick(reservation)"
                            >
                              <div class="col-12">
                                <div class="d-flex justify-content-between align-items-end flex-wrap mr-2 mr-md-0">
                                  <small class="time" style="color: #616161">
                                    {{ reservation.startDate | date: 'H:mm' }} -
                                    {{ reservation.endDate | date: 'H:mm' }}
                                  </small>
                                  <div class="tables" *ngIf="reservation.tables && reservation.tables.length">
                                    <div
                                      class="d-flex flex-nowrap"
                                      *ngIf="reservation.tables.length > 3; else tableNameTimeline"
                                    >
                                      <small>
                                        4+<i
                                          class="fas fa-puzzle-piece"
                                          matTooltip="Tischkombination {{ reservation.isTablePlan }}"
                                        ></i>
                                      </small>
                                    </div>
                                    <ng-template #tableNameTimeline>
                                      <small style="white-space: nowrap; color: #616161">
                                        <ng-container *ngFor="let table of reservation.tables; let j = index">
                                          {{ table.name
                                          }}<ng-container *ngIf="j < reservation.tables.length - 1">,</ng-container>
                                        </ng-container>
                                      </small>
                                    </ng-template>
                                  </div>
                                </div>
                                <div class="row">
                                  <div
                                    class="col-9 overflow-hidden d-flex align-items-center"
                                    style="color: rgba(0,0,0,0.87); font-weight: 500"
                                  >
                                    {{
                                      formatDisplayName(reservation?.guestData?.firstName, reservation?.guestData?.name)
                                    }}
                                    <i
                                      class="fa fa-info-circle guest-note-table-plan ml-1"
                                      *ngIf="reservation.displayMsg"
                                      [matTooltip]="reservation?.displayMsg"
                                    ></i>
                                    <i
                                      class="fa fa-info-circle admin-note-table-plan ml-1"
                                      *ngIf="reservation.notes"
                                      [matTooltip]="reservation?.notes"
                                    ></i>
                                  </div>
                                  <div class="col-3 float-right px-4 mt-1 d-flex justify-content-end">
                                    <div
                                      [ngStyle]="{
                                        fontSize: '12px',
                                        display: 'flex',
                                        justifyContent: 'flex-end'
                                      }"
                                    >
                                      <div
                                        [ngStyle]="{
                                          display: 'flex',
                                          alignItems: 'center',
                                          flexWrap: 'nowrap',
                                          color: '#616161',
                                          fontWeight: '700'
                                        }"
                                      >
                                        {{ reservation.peopleCount }} <i class="fas fa-user mx-1 "></i>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="reservation.tags" class="col-12">
                                <div class="tags">
                                  <ng-template ngFor let-tag [ngForOf]="reservation.tags">
                                    <span class="badge" [style.background-color]="tag.color">
                                      {{ tag.label }}
                                    </span>
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 pr-0">
                            <div class="reservation-info text-white px-2" [ngClass]="{ expanded: reservation.active }">
                              <div class="d-flex justify-content-between">
                                <button
                                  class="btn btn-white p-2 mt-2 uppercase w-100"
                                  id="timelineChangeStatusButton{{ i }}"
                                >
                                  <div [style.color]="getCardStatusColor(reservation)">
                                    {{ getCardStatusLabel(reservation) }}
                                  </div>
                                  <dx-context-menu
                                    [items]="sidebarStatusItems"
                                    target="#timelineChangeStatusButton{{ i }}"
                                    [width]="200"
                                    (onItemClick)="onSidebarStatusItemClick($event, reservation)"
                                    (onShowing)="refreshSidebarStatusItems(reservation)"
                                    showEvent="click"
                                  >
                                    <div
                                      *dxTemplate="let data of 'item'"
                                      style="padding: 10px"
                                      [ngStyle]="data.isActive && { color: 'white', background: '#009688' }"
                                    >
                                      <div *ngIf="data.color">
                                        <div class="item-badge" [ngStyle]="{ backgroundColor: data.color }"></div>
                                      </div>
                                      <div style="margin-left:5px">{{ data.text }}</div>
                                    </div>
                                  </dx-context-menu>
                                </button>
                              </div>
                              <div class="row">
                                <div class="col-6 overflow-hidden" style="white-space: nowrap">
                                  <small>{{ 'tablePlan.guests' | translate }}</small>
                                </div>
                                <div class="col-6 overflow-hidden" style="white-space: nowrap">
                                  <small>{{ reservation.peopleCount }} {{ 'tablePlan.persons' | translate }}</small>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-6 overflow-hidden" style="white-space: nowrap">
                                  <small>{{ 'tablePlan.stayTime' | translate }}</small>
                                </div>
                                <div class="col-6 overflow-hidden" style="white-space: nowrap">
                                  <small>{{ reservation.stayTime }} {{ 'tablePlan.minutes' | translate }}</small>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-6 overflow-hidden" style="white-space: nowrap">
                                  <small>{{ 'tablePlan.start' | translate }}</small>
                                </div>
                                <div class="col-6 overflow-hidden" style="white-space: nowrap">
                                  <small>{{ reservation.startDate | date: 'HH:mm' }}</small>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-6 overflow-hidden" style="white-space: nowrap">
                                  <small>{{ 'tablePlan.end' | translate }}</small>
                                </div>
                                <div class="col-6 overflow-hidden" style="white-space: nowrap">
                                  <small>{{ reservation.endDate | date: 'HH:mm' }}</small>
                                </div>
                              </div>
                              <div
                                class="row mb-1 additional-notes"
                                [ngStyle]="{ backgroundColor: '#fff' }"
                                *ngIf="reservation.displayMsg"
                              >
                                <div class="col-12">
                                  {{ reservation.displayMsg }}
                                </div>
                              </div>
                              <div
                                class="row additional-notes"
                                [ngStyle]="{ backgroundColor: '#e5e9f3' }"
                                *ngIf="reservation.notes"
                              >
                                <div class="col-12">
                                  {{ reservation.notes }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div *ngIf="reservations.length == 0" class="row">
                  <div class="col-md-12 text-center">
                    <h5 style="color:gray">{{ 'tablePlan.noReservations' | translate }}</h5>
                  </div>
                </div>
              </div>
              <div class="col-md-12 timeline-scheduler-col">
                <div class="element-box clearfix reservation-timeline-box">
                  <div
                    class="alert alert-warning borderless"
                    style="margin-bottom:0; margin: 10px"
                    *ngIf="!tablesData.length"
                  >
                    <h5 class="alert-heading">{{ 'tablePlan.noTables' | translate }}</h5>
                    <p>
                      {{ 'tablePlan.createTablesToUseTimelineInfo' | translate }}
                      <br />{{ 'tablePlan.createTableInSettings' | translate }}
                    </p>
                    <a
                      class="btn btn-primary"
                      routerLink="/client/{{ activeClient?.id }}/reservation/settings"
                      routerLinkActive="active"
                      [queryParams]="{ tab: 1 }"
                    >
                      {{ 'tablePlan.createTables' | translate }}
                    </a>
                  </div>
                  <dx-scheduler
                    *ngIf="dataSource && tablesData.length && bookSettings"
                    [dataSource]="dataSource"
                    [views]="[
                      { type: 'timelineDay', name: 'Tagesansicht' },
                      { type: 'timelineWeek', name: 'Wochenansicht' }
                    ]"
                    [height]="isFullscreen ? schedulerHeight : ''"
                    currentView="timelineDay"
                    [firstDayOfWeek]="0"
                    [startDayHour]="bookSettings.startTime"
                    [endDayHour]="bookSettings.endTime"
                    [cellDuration]="bookSettings && bookSettings.timeInterval ? bookSettings.timeInterval : 30"
                    [groups]="['tableId']"
                    [currentDate]="currentDate"
                    appointmentTemplate="reservation-template"
                    resourceCellTemplate="resourceCellTemplate"
                    timeCellTemplate="timeCellTemplate"
                    dateCellTemplate="dateCellTemplate"
                    appointmentCollectorTemplate="appointmentCollectorTemplate"
                    [shadeUntilCurrentTime]="true"
                    (onInitialized)="onInitialized($event)"
                    (onContentReady)="onContentReady($event)"
                    (onAppointmentRendered)="onAppointmentRendered($event)"
                    (onAppointmentUpdating)="onAppointmentUpdating($event)"
                    (onAppointmentClick)="onAppointmentClick($event)"
                    (onCellClick)="onCellClick($event)"
                    (onCellContextMenu)="onCellContextMenu($event)"
                    (onAppointmentContextMenu)="onAppointmentContextMenu($event)"
                    [showCurrentTimeIndicator]="true"
                    maxAppointmentsPerCell="unlimited"
                    crossScrollingEnabled="true"
                    class="reservations-scheduler"
                  >
                    <dxo-editing
                      #editingOptions
                      [allowAdding]="false"
                      [allowUpdating]="true"
                      [allowDeleting]="true"
                      [allowResizing]="true"
                      [allowDragging]="(!deviceService?.isMobile() && !deviceService?.isTablet()) || editMode"
                    ></dxo-editing>
                    <div *dxTemplate="let data of 'appointmentCollectorTemplate'" class="collector">
                      <div>{{ data.appointmentCount }}</div>
                    </div>
                    <div *dxTemplate="let table of 'resourceCellTemplate'">
                      <div>
                        <span class="category-name">
                          <ng-template [ngIf]="!table.data.isCombined">#{{ table.data.name }}</ng-template>
                          <ng-template [ngIf]="table.data.isCombined">Kombination {{ table.data.name }}</ng-template>
                          <!-- <br />
                                      <span class="badge badge-default" *ngIf="!table.data.isCombined">
                                        {{ table.data.seats }} {{ table.data.seats === 1 ? 'Platz' : 'Plätze' }}
                                      </span> -->
                          <ng-template [ngIf]="table.data.isCombined">
                            <small *ngFor="let comTable of table.data.combinedTables">#{{ comTable.name }} </small>
                          </ng-template>
                        </span>
                        <span class="badge badge-default category-seats" *ngIf="!table.data.isCombined">
                          {{ table.data.seats }}
                        </span>
                      </div>
                    </div>
                    <div
                      *dxTemplate="let reservation of 'reservation-template'"
                      class="status-{{ reservation.status }}"
                      [class.is-editing]="editMode"
                      [style.background-color]="reservation?.statusInfo?.color"
                    >
                      <div>
                        <div>
                          <span class="badge status-badge">
                            {{ reservation.peopleCount }}
                          </span>
                          <strong class="d-inline" *ngIf="reservation.guestData"
                            >{{ formatDisplayName(reservation.guestData?.firstName, reservation.guestData?.name) }}
                            <i
                              class="fa fa-info-circle guest-note-table-plan"
                              *ngIf="reservation.displayMsg"
                              [matTooltip]="reservation.displayMsg"
                            ></i>
                            <i
                              class="fa fa-info-circle admin-note-table-plan "
                              *ngIf="reservation.notes"
                              [matTooltip]="reservation.notes"
                            ></i>
                          </strong>
                          <strong class="d-inline" *ngIf="!reservation.guestData">Walk-In</strong>
                          <!-- <small>{{ reservation.peopleCount }} Personen</small> -->
                        </div>
                        <div class="dropdown-appointment-dates" *ngIf="false">
                          {{
                            (reservation.startDate | date: 'shortTime') +
                              ' - ' +
                              (reservation.endDate | date: 'shortTime')
                          }}
                          Uhr
                        </div>
                        <!-- <span class="badge status-badge">
                      {{ translateStatus(reservation.status) }}
                    </span> -->
                        <i
                          class="fas fa-puzzle-piece combined-icon"
                          matTooltip="Tischkombination"
                          *ngIf="reservation.combinedColor"
                          [style.color]="reservation.combinedColor"
                        ></i>
                      </div>
                    </div>
                    <dxi-resource
                      fieldExpr="ownerId"
                      [allowMultiple]="true"
                      [dataSource]="resourcesData"
                      label="Owner"
                      [useColorAsDefault]="true"
                    ></dxi-resource>
                    <dxi-resource
                      fieldExpr="tableId"
                      [allowMultiple]="false"
                      [dataSource]="tablesData"
                      label="Tisch"
                    ></dxi-resource>
                    <div *dxTemplate="let data of 'timeCellTemplate'">
                      <div [class.disabled]="isIntermediateTime(data.text)">{{ data.text }}</div>
                    </div>
                    <div *dxTemplate="let data of 'dateCellTemplate'">
                      <div>{{ data.date | dfnsFormat: 'dddd, DD. MMMM YYYY' }}</div>
                    </div>
                  </dx-scheduler>
                  <dx-context-menu
                    #reservationMenu
                    [dataSource]="reservationContextMenuItems"
                    target=".dx-scheduler-appointment"
                    (onItemClick)="onContextMenuItemClick($event)"
                    [width]="200"
                  >
                    <div *dxTemplate="let e of 'item'" class="context-menu-item">
                      <div *ngIf="e.icon">
                        <div [ngStyle]="{ color: e.color }"><i [class]="e.icon"></i></div>
                      </div>
                      <div class="item-text">{{ e.text }}</div>
                    </div>
                  </dx-context-menu>

                  <dx-context-menu
                    #cellMenu
                    [dataSource]="cellContextMenuItems"
                    target=".dx-scheduler-date-table-cell"
                    (onItemClick)="onContextMenuItemClick($event)"
                    (onShown)="onReservationContextMenuShowing($event)"
                    [width]="200"
                  >
                  </dx-context-menu>
                </div>
              </div>
            </div>
          </div>
          <div class="element-box clearfix reservation-timeline-box" *ngIf="view === 'tableplan'">
            <div
              class="alert alert-warning borderless"
              style="margin-bottom:0; margin: 10px"
              *ngIf="!tablesData.length"
            >
              <h5 class="alert-heading">Keine Tische gefunden</h5>
              <p>
                Sie haben noch keine Tische angelegt. Um die Tischplan-Ansicht zu verwenden, benötigen Sie Tische.
                <br />Erstellen Sie Tische in den Reservierungs-Einstellungen.
              </p>
              <a
                class="btn btn-primary"
                routerLink="/client/{{ activeClient?.id }}/reservation/settings"
                routerLinkActive="active"
                [queryParams]="{ tab: 1 }"
              >
                Tische erstellen
              </a>
            </div>
            <app-table-plan
              *ngIf="tablesData.length > 0"
              [isEditing]="false"
              [date]="currentDate"
              [reservations]="reservations"
              [allowDragging]="editMode"
              [isFullscreen]="isFullscreen"
              [reservationBookSettings]="bookSettings"
            ></app-table-plan>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
